import type { RoleConfig } from '../types.js';

export const wheelman: RoleConfig = {
  id: 'wheelman',
  faction: 'mafia',
  title: { ru: 'Гонщик', uk: 'Гонщик' },
  latin: 'WHEELMAN',
  number: '37',
  accent: '#b8642a',
  ability: {
    ru: 'Ночью меняет местами двух игроков — все направленные действия попадают по соседу. Мафиозный вариант Водителя.',
    uk: 'Вночі міняє місцями двох гравців — усі спрямовані дії потрапляють на сусіда. Мафіозний варіант Водія.',
  },
  abilities: [
    {
      key: 'redirect',
      phase: 'night',
      cadence: 'every-night',
      shape: 'two-target',
      canSelfTarget: true,
    },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
};
